import React, { useEffect, useMemo, useState } from 'react';
import { AppStore, AppDataContext } from './Context';
import { ServerBuilder } from '../server/config';
import { useNavigate } from 'react-router-dom';

export const AppDataProvider = ({ children }) => {
    const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem('token'));

    const navigate = useNavigate();
    const updateAlert = (message, type, severity) => {
        store.update({
            alertError: {
                message,
                type,
                severity
            }
        });
    };
    const updatePermissions = (permissions) => {
        store.update({
            permissions
        });
    };

    const initialState = {
        userInfo: {
            id: null,
            firstName: null,
            lastName: null,
            email: null,
            role: null,
            position: null,
            mobilePhone: null
        },
        permissions: {},
        actions: {},
        controllersData: {},
        reportsData: [],
        alertError: { message: '', type: 'snackbar', severity: 'error' },
        server: new ServerBuilder({
            updateAlertError: updateAlert,
            updatePermissions,
            setLoggedIn,
            navigate
        }).build()
    };

    const store = useMemo(() => new AppStore(initialState), []);

    const fetchServerData = async (serverRequest) => {
        try {
            const metaData = await serverRequest.users.metaInfo();

            if (!metaData) {
                throw new Error('Received empty metadata from server.');
            }

            const { permissions, currentUser, actionPermissions, csvExportEnableControllers } = metaData;
            const controllers = permissions ? Object.keys(permissions) : [];

            store.update({
                userInfo: currentUser || {},
                permissions: permissions || {},
                actions: actionPermissions || {},
                csvExportEnableControllers: csvExportEnableControllers || [],
                controllersData: {
                    ...store.getState().controllersData,
                    controllers
                }
            });

            console.log('Successfully updated store state.');
        } catch (error) {
            console.error('Failed to fetch server data:', error);
        }
    };

    const resetStore = () => {
        store.update({
            permissions: {},
            actions: {},
            controllersData: {},
            userInfo: {},
            images: {},
            alertError: { message: '', type: 'snackbar', status: 'error' }
        });
    };

    useEffect(() => {
        if (loggedIn && store.getState().server) {
            fetchServerData(store.getState().server)
                .then(() => {
                })
                .catch((error) => {
                    console.error('Unexpected error:', error);
                });
        } else {
            resetStore();
        }
    }, [loggedIn]);

    return (
        <AppDataContext.Provider value={store}>
            {children}
        </AppDataContext.Provider>
    );
};
